// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function makeResult(data, error, loadingOpt, toJson) {
  var loading = loadingOpt !== undefined ? loadingOpt : false;
  return {
          data: Belt_Option.mapWithDefault(data, null, Curry.__1(toJson)),
          error: Belt_Option.mapWithDefault(error, null, (function (prim) {
                  return prim;
                })),
          loading: loading
        };
}

var Graphql;

var ApolloError;

export {
  Graphql ,
  ApolloError ,
  makeResult ,
}
/* No side effect */
